export const CTestimonialsSliderFragments = {
  field: `
    fragment testimonialsSlider on testimonialsSlider_MatrixField {
      ... on testimonialsSlider_block_Entry {
        id
        typeHandle
        idName
        heading
        disableBordersOnMobile
        footerText
        testimonials {
          id
          title
          slug
          ... on testimonials_Entry {
            testimonialOccupation
            testimonialQuote
            testimonialImage {
              url
              title
            }
            testimonialVideo {
              url
              title
              embeddedAsset {
                url
                title
              }
            }
            testimonialVideoOrientation
          }
          ... on testimonialPages_Entry {
            testimonialOccupation
            testimonialQuote
            testimonialImage {
              url
              title
            }
            testimonialVideo {
              url
              title
              embeddedAsset {
                url
                title
              }
            }
            testimonialVideoOrientation
            testimonialsImagePosition
          }
        }
      }
    }
  `,
}
